import { c as _c } from "react/compiler-runtime";
import { cn } from '@/hooks/utils';
import React from 'react';
import { ImageComponent } from '@/components/ui/ImageComponent';
interface TestimonialBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  quote: string;
  author: string;
  role: string;
  company: string;
  image: string;
  logo: string;
  imageClassName?: string;
  imageWrapperClassName?: string;
  imageWrapperOuterClassName?: string;
  authorClassName?: string;
  roleClassName?: string;
  className?: string;
  testimonialClassName?: string;
  logoClassName?: string;
}
export function TestimonialBox(t0) {
  const $ = _c(58);
  let author;
  let authorClassName;
  let className;
  let company;
  let image;
  let imageClassName;
  let imageWrapperClassName;
  let logo;
  let logoClassName;
  let quote;
  let rest;
  let role;
  let roleClassName;
  let testimonialClassName;
  if ($[0] !== t0) {
    const {
      quote: t1,
      author: t2,
      role: t3,
      company: t4,
      image: t5,
      logo: t6,
      imageClassName: t7,
      imageWrapperClassName: t8,
      imageWrapperOuterClassName,
      authorClassName: t9,
      roleClassName: t10,
      className: t11,
      testimonialClassName: t12,
      logoClassName: t13,
      ...t14
    } = t0;
    quote = t1;
    author = t2;
    role = t3;
    company = t4;
    image = t5;
    logo = t6;
    imageClassName = t7;
    imageWrapperClassName = t8;
    authorClassName = t9;
    roleClassName = t10;
    className = t11;
    testimonialClassName = t12;
    logoClassName = t13;
    rest = t14;
    $[0] = t0;
    $[1] = author;
    $[2] = authorClassName;
    $[3] = className;
    $[4] = company;
    $[5] = image;
    $[6] = imageClassName;
    $[7] = imageWrapperClassName;
    $[8] = logo;
    $[9] = logoClassName;
    $[10] = quote;
    $[11] = rest;
    $[12] = role;
    $[13] = roleClassName;
    $[14] = testimonialClassName;
  } else {
    author = $[1];
    authorClassName = $[2];
    className = $[3];
    company = $[4];
    image = $[5];
    imageClassName = $[6];
    imageWrapperClassName = $[7];
    logo = $[8];
    logoClassName = $[9];
    quote = $[10];
    rest = $[11];
    role = $[12];
    roleClassName = $[13];
    testimonialClassName = $[14];
  }
  let t1;
  if ($[15] !== className) {
    t1 = cn("flex h-full w-full max-w-[512px] gap-5 flex-col justify-between rounded-[24px] sm:rounded-[32px] bg-white p-5 shadow-[0_0_54px_0_rgba(0,0,0,0.02)] sm:p-8 sm:gap-[65px]", className);
    $[15] = className;
    $[16] = t1;
  } else {
    t1 = $[16];
  }
  let t2;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-[2px] font-bricolage text-[24px] sm:text-[40px] tracking-[-0.8px] font-bold leading-none text-[#0B0623]">“</div>;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== testimonialClassName) {
    t3 = cn("font-sans text-[14px] sm:text-2xl leading-relaxed text-[#302B44]", testimonialClassName);
    $[18] = testimonialClassName;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== quote || $[21] !== t3) {
    t4 = <div>{t2}<blockquote className={t3}>{quote}</blockquote></div>;
    $[20] = quote;
    $[21] = t3;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== imageClassName) {
    t5 = cn("z-1 object-contain overflow-auto", imageClassName);
    $[23] = imageClassName;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== imageWrapperClassName) {
    t6 = cn("relative max-w-[120px] h-[160px]", imageWrapperClassName);
    $[25] = imageWrapperClassName;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== author || $[28] !== image || $[29] !== t5 || $[30] !== t6) {
    t7 = <ImageComponent src={image} alt={author} fill={true} className={t5} containerClassName={t6} />;
    $[27] = author;
    $[28] = image;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== authorClassName) {
    t8 = cn("font-bricolage text-[13px] sm:text-[16px] font-bold leading-tight text-[#0B0623]", authorClassName);
    $[32] = authorClassName;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== author || $[35] !== t8) {
    t9 = <div className={t8}>{author}</div>;
    $[34] = author;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== roleClassName) {
    t10 = cn("mt-0.5 font-sans text-[11px] sm:text-[16px] text-[#302B44]", roleClassName);
    $[37] = roleClassName;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== role || $[40] !== t10) {
    t11 = <div className={t10}>{role}</div>;
    $[39] = role;
    $[40] = t10;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  let t12;
  if ($[42] !== company || $[43] !== logo || $[44] !== logoClassName) {
    t12 = logo && <ImageComponent src={logo} alt={company} fill={true} className="object-contain object-left" containerClassName={cn("mt-2 relative h-9", logoClassName)} />;
    $[42] = company;
    $[43] = logo;
    $[44] = logoClassName;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== t11 || $[47] !== t12 || $[48] !== t9) {
    t13 = <div>{t9}{t11}{t12}</div>;
    $[46] = t11;
    $[47] = t12;
    $[48] = t9;
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  let t14;
  if ($[50] !== t13 || $[51] !== t7) {
    t14 = <div className="flex items-center gap-4">{t7}{t13}</div>;
    $[50] = t13;
    $[51] = t7;
    $[52] = t14;
  } else {
    t14 = $[52];
  }
  let t15;
  if ($[53] !== rest || $[54] !== t1 || $[55] !== t14 || $[56] !== t4) {
    t15 = <div className={t1} {...rest}>{t4}{t14}</div>;
    $[53] = rest;
    $[54] = t1;
    $[55] = t14;
    $[56] = t4;
    $[57] = t15;
  } else {
    t15 = $[57];
  }
  return t15;
}